import { createScope, ScopeProvider } from 'bunshi/react';
import { PropsWithChildren } from 'react';

type Section =
  | 'transactions'
  | 'transactions-rules'
  | 'invoices-issued'
  | 'invoices-received'
  | 'bills'
  | 'flows'
  | 'delivery-documents'
  | 'payments'
  | 'cashflow'
  | 'quote'
  | 'bookkeeping-transactions'
  | 'bookkeeping-ledger-cards'
  | 'referral'
  | 'taxDebitCredits'
  | 'f24'
  | 'automatic-payment-reminders';

export const SectionScope = createScope<Section | null>(null);

interface Props {
  section: Section;
}

export const SectionScopeProvider: React.FC<PropsWithChildren<Props>> = ({ children, section }) => {
  return (
    <ScopeProvider scope={SectionScope} value={section}>
      {children}
    </ScopeProvider>
  );
};
